export default __webpack_public_path__ + "a51ffc7d2321d91b6ec8b68fd3d60eed.png";